(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8144],{

/***/ 17285:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AmpStateContext = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AmpStateContext = _react["default"].createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ 49546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isInAmpMode = isInAmpMode;
exports.useAmp = useAmp;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _ampContext = __webpack_require__(17285);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

function useAmp() {
  // Don't assign the context value to a variable to save bytes
  return isInAmpMode(_react["default"].useContext(_ampContext.AmpStateContext));
}

if (typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) {
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 16505:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty = __webpack_require__(930);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _sideEffect = _interopRequireDefault(__webpack_require__(70148));

var _ampContext = __webpack_require__(17285);

var _headManagerContext = __webpack_require__(60523);

var _amp = __webpack_require__(49546);

var _utils = __webpack_require__(67206);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react["default"].createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react["default"].createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react["default"].Fragment) {
    return list.concat(_react["default"].Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
 returns a function for filtering head child elements
 which shouldn't be duplicated, like <title/>
 Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;
    var hasKey = false;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      hasKey = true;
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if ((metatype !== 'name' || !hasKey) && categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
 *
 * @param headElements List of multiple <Head> instances
 */


function reduceComponents(headElements, props) {
  return headElements.reduce(function (list, headElement) {
    var headElementChildren = _react["default"].Children.toArray(headElement.props.children);

    return list.concat(headElementChildren);
  }, []).reduce(onlyReactElement, []).reverse().concat(defaultHead(props.inAmpMode)).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if ( true && !props.inAmpMode) {
      if (c.type === 'link' && c.props['href'] && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
      ['https://fonts.googleapis.com/css', 'https://use.typekit.net/'].some(function (url) {
        return c.props['href'].startsWith(url);
      })) {
        var newProps = _objectSpread({}, c.props || {});

        newProps['data-href'] = newProps['href'];
        newProps['href'] = undefined; // Add this attribute to make it easy to identify optimized tags

        newProps['data-optimized-fonts'] = true;
        return /*#__PURE__*/_react["default"].cloneElement(c, newProps);
      }
    }

    if (false) { var srcMessage; }

    return /*#__PURE__*/_react["default"].cloneElement(c, {
      key: key
    });
  });
}
/**
 * This component injects elements to `<head>` of your page.
 * To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
 */


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react).useContext(_ampContext.AmpStateContext);
  var headManager = (0, _react).useContext(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react["default"].createElement(_sideEffect["default"], {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _amp).isInAmpMode(ampState)
  }, children);
}

var _default = Head;
exports["default"] = _default;

if (typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) {
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 70148:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _toConsumableArray = __webpack_require__(7980);

var _classCallCheck = __webpack_require__(33227);

var _createClass = __webpack_require__(88361);

var _assertThisInitialized = __webpack_require__(92191);

var _inherits = __webpack_require__(85971);

var _possibleConstructorReturn = __webpack_require__(52715);

var _getPrototypeOf = __webpack_require__(91193);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var isServer = false;

var _class = /*#__PURE__*/function (_react$Component) {
  _inherits(_class, _react$Component);

  var _super = _createSuper(_class);

  function _class(props) {
    var _this;

    _classCallCheck(this, _class);

    _this = _super.call(this, props);

    _this.emitChange = function () {
      if (_this._hasHeadManager) {
        _this.props.headManager.updateHead(_this.props.reduceComponentsToState(_toConsumableArray(_this.props.headManager.mountedInstances), _this.props));
      }
    };

    _this._hasHeadManager = _this.props.headManager && _this.props.headManager.mountedInstances;

    if (isServer && _this._hasHeadManager) {
      _this.props.headManager.mountedInstances.add(_assertThisInitialized(_this));

      _this.emitChange();
    }

    return _this;
  }

  _createClass(_class, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances.add(this);
      }

      this.emitChange();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.emitChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances["delete"](this);
      }

      this.emitChange();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return _class;
}(_react.Component);

exports["default"] = _class;

/***/ }),

/***/ 70770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var titleText = _ref.titleText,
      subTitleText = _ref.subTitleText,
      enTitleText = _ref.enTitleText,
      color = _ref.color,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h3' : _ref$as;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionTitleDiv, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleText, {
      color: color,
      as: as,
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EnTitleText, {
      color: color,
      as: as,
      children: enTitleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubTitleText, {
      color: color,
      children: subTitleText
    })]
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-17562y0-0"
})(["text-align:center;"]);
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__TitleText",
  componentId: "sc-17562y0-1"
})(["font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";@media screen and (max-width:1047px){display:none;}"], function (_ref2) {
  var color = _ref2.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var SubTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "SectionTitle__SubTitleText",
  componentId: "sc-17562y0-2"
})(["font-size:18px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref3) {
  var color = _ref3.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.overlay */ .r.colors.overlay) : "white";
});
var EnTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__EnTitleText",
  componentId: "sc-17562y0-3"
})(["@media screen and (min-width:1048px){font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";}@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref4) {
  var color = _ref4.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);

/***/ }),

/***/ 75795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ SectionTitleBackground; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var _utils_convertPx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98993);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var SectionTitleBackground = function SectionTitleBackground(_ref) {
  var children = _ref.children,
      rest = (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Wrapper, _objectSpread(_objectSpread({}, rest), {}, {
    children: children
  }));
};
var Arrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["content:'';position:absolute;left:0;width:0;height:0;border-style:solid;border-width:", " 50vw 0 50vw;@media screen and (max-width:1047px){border-width:40px 50vw 0 50vw;}"], (0,_utils_convertPx__WEBPACK_IMPORTED_MODULE_5__/* .PxToVw */ .g)(130, 1440));
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitleBackground__Wrapper",
  componentId: "sc-venkor-0"
})(["position:relative;background-color:", ";padding:", ";&::before{", ";top:0;border-color:", ";}&::after{", ";bottom:0;border-color:", ";}@media screen and (max-width:1047px){padding:", ";}"], function (_ref2) {
  var bgColor = _ref2.bgColor;
  return bgColor === 'trial-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : bgColor === 'thin-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue) : '#fff';
}, function (_ref3) {
  var padding = _ref3.padding;
  return padding.pc;
}, Arrow, function (_ref4) {
  var outerBgColor = _ref4.outerBgColor;
  return "".concat(outerBgColor === 'thin-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue) : '#fff', " \n      transparent transparent transparent");
}, Arrow, function (_ref5) {
  var bgColor = _ref5.bgColor,
      outerBgColor = _ref5.outerBgColor;
  return "".concat(bgColor === 'trial-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : bgColor === 'thin-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue) : '#fff', " \n      ").concat(outerBgColor === 'thin-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue) : '#fff', " \n      transparent \n      ").concat(outerBgColor === 'thin-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue) : '#fff');
}, function (_ref6) {
  var padding = _ref6.padding;
  return padding.sp;
});

/***/ }),

/***/ 32056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | TRIAL Holdings, Inc.") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 54413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ RecentNewsList; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var _hooks_useMpocketScript__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98259);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var RecentNewsList = function RecentNewsList() {
  (0,_hooks_useMpocketScript__WEBPACK_IMPORTED_MODULE_1__/* .useMpocketScript */ .k)('//irpocket.com/141A/irpocket/config-utils-main_en.js'); // useMpocketScript('//irpocket.com/5882/irpocket/config-utils-main_en.js')

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(NewsList, {
    id: "irp-top-list"
  });
};
var NewsList = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "RecentNewsList__NewsList",
  componentId: "sc-58sqmo-0"
})(["display:flex;flex-direction:column;gap:30px;@media screen and (max-width:1047px){gap:24px;}> article{padding-bottom:30px;:not(:last-child){border-bottom:1px solid ", ";}@media screen and (max-width:1047px){padding-bottom:24px;}> a{display:flex;cursor:pointer;gap:50px;&:hover > div > h3{> svg{fill:", ";}> p{text-decoration:underline;color:", ";> span{color:", ";display:inline-block;}}}@media screen and (max-width:1047px){flex-direction:column;row-gap:14px;}> time{font-weight:700;font-size:14px;line-height:1.6;letter-spacing:0;color:", ";}> div{display:flex;flex-direction:column;row-gap:14px;> ul{display:flex;flex-wrap:wrap;gap:12px;> li{font-size:13px;text-align:center;line-height:1;color:", ";list-style:none;min-width:82px;padding:6px 13px;border:1pt solid;border-radius:2pt;border-color:", ";}}> h3{display:flex;gap:10px;transition:fill 0.3s ease;@media screen and (max-width:1047px){font-size:15px;line-height:24px;letter-spacing:0;}> svg{fill:", ";width:12px;height:28px;flex-shrink:0;}> p{font-size:16px;letter-spacing:0.64px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:15px;}> span{font-weight:500;font-size:13px;line-height:1.6;color:", ";margin-left:10px;@media screen and (max-width:1047px){font-size:11px;}}}}}}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textSecond */ .r.colors.textSecond);

/***/ }),

/***/ 82592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Os": function() { return /* binding */ AHeading; },
/* harmony export */   "V": function() { return /* binding */ CHeading; },
/* harmony export */   "Zg": function() { return /* binding */ BHeading; },
/* harmony export */   "ac": function() { return /* binding */ DHeading; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var AHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
  displayName: "Heading__AHeading",
  componentId: "sc-ywkeww-0"
})(["font-size:28px;font-weight:700;line-height:1.2;color:", ";border-bottom:1px solid ", ";padding-bottom:22px;margin-bottom:50px;@media screen and (max-width:1047px){font-size:19px;padding-bottom:10px;margin-bottom:30px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.grey */ .r.colors.grey);
var BHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "Heading__BHeading",
  componentId: "sc-ywkeww-1"
})(["font-size:24px;font-weight:700;line-height:140%;color:", ";margin-bottom:36px;@media screen and (max-width:1047px){font-size:20px;line-height:130%;margin-bottom:26px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var CHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
  displayName: "Heading__CHeading",
  componentId: "sc-ywkeww-2"
})(["font-size:18px;font-weight:700;line-height:140%;margin-bottom:20px;@media screen and (max-width:1047px){font-size:16px;line-height:130%;margin-bottom:18px;}"]);
var DHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
  displayName: "Heading__DHeading",
  componentId: "sc-ywkeww-3"
})(["font-size:32px;font-weight:700;line-height:100%;color:", ";@media screen and (max-width:1047px){font-size:24px;line-height:130%;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 98259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useMpocketScript; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50029);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


// 修正案1

console.log('4');
var useMpocketScript = function useMpocketScript(src) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoaded = _useState[0],
      setIsLoaded = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      error = _useState2[0],
      setError = _useState2[1]; // エラー状態をstringまたはnullで初期化


  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (false) {} // SSR対策

    var loadScript = /*#__PURE__*/function () {
      var _ref = (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return new Promise(function (resolve, reject) {
                  var scriptElement = document.createElement('script');
                  var srcWithTime = src;
                  var time = new Date().getTime();

                  if (srcWithTime.includes('?')) {
                    srcWithTime += "&_t=".concat(time);
                  } else {
                    srcWithTime += "?_t=".concat(time);
                  }

                  scriptElement.src = srcWithTime;
                  scriptElement.async = true;
                  console.log('scriptElement.src:', scriptElement.src);
                  document.body.appendChild(scriptElement); // console.log(`新しいスクリプトを作成しています: ${src}, 非同期設定: ${scriptElement.async}`);

                  // console.log(`新しいスクリプトを作成しています: ${src}, 非同期設定: ${scriptElement.async}`);
                  var existingScript = document.querySelector("script[src*=\"".concat(src, "\"]"));

                  if (existingScript) {
                    console.log("\u30B9\u30AF\u30EA\u30D7\u30C8\u304C\u65E2\u306B\u30DA\u30FC\u30B8\u306B\u5B58\u5728\u3057\u307E\u3059: ".concat(src));
                    resolve(existingScript);
                    return;
                  } else {
                    console.log("\u30B9\u30AF\u30EA\u30D7\u30C8\u304C\u30DA\u30FC\u30B8\u306B\u5B58\u5728\u3057\u307E\u305B\u3093\u3001\u8FFD\u52A0\u3057\u307E\u3059: ".concat(src));
                  } // const scriptElement = document.createElement('script');
                  // scriptElement.src = src;
                  // scriptElement.async = true;


                  // const scriptElement = document.createElement('script');
                  // scriptElement.src = src;
                  // scriptElement.async = true;
                  scriptElement.onload = function () {
                    console.log('マジカルポケットの外部スクリプトが読み込まれました。');
                    console.log('scriptElement.src:', scriptElement.src);
                    setIsLoaded(true);
                    resolve(scriptElement);
                  };

                  scriptElement.onerror = function () {
                    var errorMessage = 'マジカルポケットの外部スクリプトの読み込みに失敗しました。';
                    console.error(errorMessage);
                    setError(errorMessage); // カスタムエラーメッセージをセット

                    // カスタムエラーメッセージをセット
                    reject(new Error(errorMessage));
                  }; // document.body.appendChild(scriptElement);


                  // document.body.appendChild(scriptElement);
                  console.log("\u30B9\u30AF\u30EA\u30D7\u30C8\u304CDOM\u306B\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F: ".concat(src));
                });

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                setError(_context.t0 instanceof Error ? _context.t0.message : String(_context.t0));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 5]]);
      }));

      return function loadScript() {
        return _ref.apply(this, arguments);
      };
    }();

    loadScript();
  }, [src]);
  return {
    isLoaded: isLoaded,
    error: error
  };
};
/*
import { useEffect, useState } from 'react';

export const useMpocketScript = (src: string) => {
  const [isLoaded, setIsLoaded] = useState(false);  // スクリプト(js)読込状況の確認用
  const [error, setError] = useState<string | null>(null);  // エラーメッセージ格納用

  useEffect(() => {
    if (typeof window === 'undefined') return; // SSR対策とスクリプト読み込みフラグ確認

    const loadScript = () => {
      //Promiseを利用した非同期処理
      //各種読み込み状態・処理状態に応じた処理を行うため、Promiseを使用
      return new Promise((resolve, reject) => {
        // 既に同じsrcのスクリプトが存在するか確認
        const existingScript = document.querySelector(`script[src="${src}"]`);  

        if (existingScript) { // 存在している場合
          console.log(`スクリプトが既にページに存在します: ${src}`);
          setIsLoaded(true);
          resolve(existingScript);
          return;
        }
        
        // 新しいスクリプト要素の作成
        const scriptElement = document.createElement('script');
        scriptElement.src = src;
        scriptElement.async = true; // 非同期での読込。可読性重視のため、asyncを採用

        // スクリプトの読込成功時
        scriptElement.onload = () => {
          console.log('外部スクリプトが読み込まれました。');
          setIsLoaded(true);
          resolve(scriptElement);
        };

        // スクリプトの読込失敗時
        scriptElement.onerror = () => {
          const errorMessage = '外部スクリプトの読み込みに失敗しました。';
          console.error(errorMessage);
          setError(errorMessage);
          reject(new Error(errorMessage));  //エラーで拒否
        };

        // スクリプトをDOMに追加
        const appendScript = () => {
          if (document.body) {
            document.body.appendChild(scriptElement);
            console.log(`スクリプトがDOMに追加されました: ${src}`);
          } else {
            console.error('document.bodyが存在しません。スクリプトの追加に失敗しました。');
            reject(new Error('document.bodyが存在しません。スクリプトの追加に失敗しました。')); //エラーで拒否
          }
        };

        // ドキュメントの準備状態に応じて作業を変更
        if (document.readyState === 'loading') {   // ドキュメントが読み込み中の場合
          document.addEventListener('DOMContentLoaded', appendScript);
        } else {  // ドキュメントが読み込み済みの場合
          appendScript();
        }
      });
    };

    // スクリプトを同期的に読込
    //　可読性重視、ハンドリングの容易さを重視しての、async選択
    const syncLoadScript = async () => {
      try {
        await loadScript(); // スクリプトの読み込み待ち
      } catch (error) { // エラーが発生時
        setError(error instanceof Error ? error.message : String(error));
      }
    };

    syncLoadScript(); // スクリプトの同期読込
  }, [src]);

  return { isLoaded, error };
};

*/

/***/ }),

/***/ 91909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ en; }
});

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(21082);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(36797);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/utils/convertPx.ts
var convertPx = __webpack_require__(98993);
// EXTERNAL MODULE: ./src/components/elements/Line/index.tsx
var Line = __webpack_require__(9945);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/enpages/Home/PickUpItem.tsx






var PickUpItem = function PickUpItem(_ref) {
  var link = _ref.link,
      imgPath = _ref.imgPath,
      imgWidth = _ref.imgWidth,
      imgHeight = _ref.imgHeight,
      title = _ref.title,
      alignItems = _ref.alignItems,
      cssProp = _ref.cssProp;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PickUpItemStyled, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: link,
      passHref: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PickUpItemImage, {
          alignItems: alignItems,
          cssProp: cssProp,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: imgPath,
            alt: title,
            width: imgWidth,
            height: imgHeight
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PickUpItemTitle, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              children: title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(PickUpLine, {
              color: "trialBlue",
              direction: "horizon",
              weight: 4
            })]
          })
        })]
      })
    })
  });
};
var PickUpItemStyled = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "PickUpItem__PickUpItemStyled",
  componentId: "sc-4ybfkh-0"
})(["background-color:white;border-radius:8px;width:311px;a{display:flex;flex-direction:column;align-items:center;padding:45px 0;img{transition:opacity 0.25s ease;}&:hover{h3{color:", ";}img{opacity:0.6;}}}@media screen and (max-width:1047px){height:164px;width:100%;max-width:350px;a{padding:20px 10% 24px;flex-direction:row;height:100%;}}"], theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);
var PickUpLine = (0,styled_components_browser_esm/* default */.ZP)(Line/* Line */.x).withConfig({
  displayName: "PickUpItem__PickUpLine",
  componentId: "sc-4ybfkh-1"
})(["transition:background-color 0.25s ease;", ":hover &{background-color:", ";}"], PickUpItemStyled, theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);
var PickUpItemImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PickUpItem__PickUpItemImage",
  componentId: "sc-4ybfkh-2"
})(["width:185px;height:185px;display:flex;flex-direction:column;justify-content:end;position:relative;width:185px;height:185px;border-radius:50%;background-color:", ";align-items:", ";@media screen and (max-width:1047px){width:90px;height:90px;justify-content:center;", ";}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue, function (_ref2) {
  var alignItems = _ref2.alignItems;
  return alignItems;
}, function (_ref3) {
  var cssProp = _ref3.cssProp;
  return cssProp;
});
var PickUpItemTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PickUpItem__PickUpItemTitle",
  componentId: "sc-4ybfkh-3"
})(["margin-top:22px;h3{font-size:20px;font-weight:bold;line-height:29px;margin-bottom:8px;transition:color 0.25s ease;}@media screen and (max-width:1047px){width:50%;margin-top:0;margin-left:13px;flex:1;text-align:center;> div{display:inline-block;}h3{text-align:center;margin-bottom:0;}}@media screen and (max-width:360px){h3{font-size:16px;}}"]);
// EXTERNAL MODULE: ./src/components/elements/Button/index.tsx
var Button = __webpack_require__(96738);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/SectionTitleBackground/index.tsx
var SectionTitleBackground = __webpack_require__(75795);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/enlayout.tsx + 7 modules
var enlayout = __webpack_require__(34591);
// EXTERNAL MODULE: ./src/components/enlayouts/Head/index.tsx
var Head = __webpack_require__(32056);
// EXTERNAL MODULE: ./src/components/enpages/Ir/RecentNewsList.tsx
var RecentNewsList = __webpack_require__(54413);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Heading.tsx
var Heading = __webpack_require__(82592);
;// CONCATENATED MODULE: ./src/components/enpages/Home/index.tsx









 // import { NewsItem } from '@/components/elements/News/NewsItem'











swiper_esm/* default.use */.ZP.use([swiper_esm/* Pagination */.tl, swiper_esm/* Navigation */.W_, swiper_esm/* Autoplay */.pt]);
var HomePage = function HomePage(_ref) {
  var newsRelease = _ref.newsRelease;
  var images = ['/images/home-slide-1.webp', '/images/home-slide-2.webp', '/images/home-slide-3.webp', '/images/home-slide-4.webp', '/images/home-slide-5.webp'];
  var pickupList = [{
    link: 'en/company/topmessage/',
    imgPath: '/images/home-top-message.svg',
    imgWidth: 133,
    imgHeight: 174,
    title: 'Top Message',
    alignItems: 'flex-end',
    cssProp: (0,styled_components_browser_esm/* css */.iv)(["img{max-width:100%;transform:translateX(23%);}"])
  }, {
    link: 'en/company/philosophy/',
    imgPath: '/images/home-philosophy.svg',
    imgWidth: 100,
    imgHeight: 195,
    title: 'Philosophy',
    alignItems: 'center',
    cssProp: (0,styled_components_browser_esm/* css */.iv)(["img{max-height:120px;}"])
  } // {
  //   link: 'en/news/blog/',
  //   imgPath: '/images/home-pr-blog.svg',
  //   imgWidth: 186,
  //   imgHeight: 147,
  //   title: 'Public relations blog',
  //   alignItems: 'center',
  //   cssProp: css`
  //     img {
  //       max-width: 112px;
  //       transform: translateY(6%);
  //     }
  //   `,
  // },
  ];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(enlayout/* Layout */.Ar, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
        title: "TRIAL Holdings, Inc. | Enrich every aspect of people's lives through Retail DX.",
        hasTitleSuffix: false,
        description: "TRIAL Holdings envisions 'Enrich every aspect of people's lives through all we do.' We are a company that promotes the transformation of global real commerce through technology and human experiential knowledge.",
        ogp: {
          url: ''
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TopSlider, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SlideWrapper, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "Enrich every aspect of people's lives through all we do."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
              style: {
                zIndex: 1
              },
              slidesPerView: 1,
              pagination: {
                clickable: true,
                bulletClass: "swiper-pagination-bullet custom-bullet",
                bulletActiveClass: "swiper-pagination-bullet-active custom-bullet-active"
              },
              loop: true,
              autoplay: {
                delay: 4000,
                disableOnInteraction: false
              },
              speed: 2000,
              children: images.map(function (src, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(SlideImage, {
                    src: src,
                    alt: ""
                  })
                }, "".concat(index));
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(NewsRoom, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SubSectionTitle, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* DHeading */.ac, {
              children: "News Release"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/en/news/release/",
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsMoreButton, {
                  btnStyle: "transparent",
                  children: "See More"
                })
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              sp: 30,
              pc: 80
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(EnNewslist, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("time", {
                children: "2023/12/28"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: "/en/news/ennews",
                  children: "Establishment of The English Version of The Website"
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              sp: 34,
              pc: 90
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SubSectionTitle, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* DHeading */.ac, {
              children: "IR News"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/en/ir/news/",
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsMoreButton, {
                  btnStyle: "transparent",
                  children: "See More"
                })
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              sp: 30,
              pc: 80
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(IRNewsList, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(RecentNewsList/* RecentNewsList */.M, {})
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            pc: 30,
            sp: 50
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PickUp, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SectionTitleBackground/* SectionTitleBackground */.T, {
            padding: {
              pc: "".concat((0,convertPx/* PxToVw */.g)(210, 1440), " 0 ").concat((0,convertPx/* PxToVw */.g)(130, 1440)),
              sp: "87px 0 80px"
            },
            bgColor: "trial-blue",
            outerBgColor: "white",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
              color: "white",
              titleText: "Pick Up",
              subTitleText: "",
              as: "h2"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(PickUpList, {
              children: pickupList.map(function (_ref2) {
                var link = _ref2.link,
                    imgPath = _ref2.imgPath,
                    title = _ref2.title,
                    imgWidth = _ref2.imgWidth,
                    imgHeight = _ref2.imgHeight,
                    alignItems = _ref2.alignItems,
                    cssProp = _ref2.cssProp;
                return /*#__PURE__*/(0,jsx_runtime.jsx)(PickUpItem, {
                  link: link,
                  imgPath: imgPath,
                  title: title,
                  imgWidth: imgWidth,
                  imgHeight: imgHeight,
                  alignItems: alignItems,
                  cssProp: cssProp
                }, title);
              })
            })]
          })
        })]
      })]
    })
  });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Home__Wrapper",
  componentId: "sc-2heyus-0"
})(["overflow:hidden;"]);
var SlideImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Home__SlideImage",
  componentId: "sc-2heyus-1"
})(["width:100vw;height:", ";"], (0,convertPx/* PxToVw */.g)(643, 1440));
var TopSlider = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "Home__TopSlider",
  componentId: "sc-2heyus-2"
})([".swiper-pagination{bottom:27px;}.swiper-pagination-bullet.custom-bullet{background-color:#fff;margin:0 18px !important;width:14px;height:14px;opacity:1;}.swiper-pagination-bullet-active.custom-bullet-active{background-color:", ";}@media screen and (max-width:1047px){.swiper-pagination{position:relative !important;bottom:5px;margin-top:13px;}.swiper-pagination-bullet.custom-bullet{width:11px;height:11px;background-color:", ";}.swiper-pagination-bullet-active.custom-bullet-active{background-color:", ";}}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.colors.backgroundBlue */.r.colors.backgroundBlue, theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var NewsRoom = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "Home__NewsRoom",
  componentId: "sc-2heyus-3"
})(["width:1040px;margin:90px auto 0;@media screen and (max-width:1047px){width:100%;margin:40px auto 0;}"]); // const NewsList = styled.div`
//   margin-top: 70px;
//   display: flex;
//   flex-direction: column;
//   gap: 24px;
//   @media screen and (max-width: 1047px) {
//     margin-top: 34px;
//     padding: 0 20px;
//   }
// `
// const NewsMoreButton = styled.div`
//   margin-top: 60px;
//   display: flex;
//   justify-content: center;
//   @media screen and (max-width: 1047px) {
//     margin-top: 40px;
//   }
// `

var NewsMoreButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
  displayName: "Home__NewsMoreButton",
  componentId: "sc-2heyus-4"
})(["padding:11px 26px 13px 26px;width:135px;height:40px;font-size:16px;font-weight:500;@media screen and (max-width:1047px){padding:2px 18px 4px 18px;font-size:13px;width:104px;height:32px;}"]);
var PickUp = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "Home__PickUp",
  componentId: "sc-2heyus-5"
})(["> div::after{display:none;}"]);
var PickUpList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "Home__PickUpList",
  componentId: "sc-2heyus-6"
})(["margin:70px auto 0;display:flex;justify-content:space-around;column-gap:30px;width:1040px;@media screen and (max-width:1047px){width:100%;margin:34px auto 0;flex-direction:column;align-items:center;row-gap:30px;padding:0 20px;}"]);
var SlideWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Home__SlideWrapper",
  componentId: "sc-2heyus-7"
})(["position:relative;p{z-index:2;top:", ";color:#fff;font-size:", ";font-weight:bold;letter-spacing:3.2px;line-height:46px;background-color:rgba(0,45,101,0.9);padding-top:", ";padding-left:", ";padding-bottom:", ";padding-right:20px;br{display:none;}}@media screen and (max-width:1000px){p{font-size:", ";letter-spacing:1.4px;line-height:26px;line-height:", ";padding-top:", ";padding-bottom:", ";padding-right:", ";padding-left:", ";br{display:block;}}}"], (0,convertPx/* PxToVw */.g)(110, 1440), (0,convertPx/* PxToVw */.g)(30, 1440), (0,convertPx/* PxToVw */.g)(20, 1440), (0,convertPx/* PxToVw */.g)(100, 1440), (0,convertPx/* PxToVw */.g)(20, 1440), (0,convertPx/* PxToVw */.g)(14, 390), (0,convertPx/* PxToVw */.g)(20, 390), (0,convertPx/* PxToVw */.g)(5, 390), (0,convertPx/* PxToVw */.g)(5, 390), (0,convertPx/* PxToVw */.g)(24, 390), (0,convertPx/* PxToVw */.g)(34, 390));
var SubSectionTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Home__SubSectionTitle",
  componentId: "sc-2heyus-8"
})(["display:flex;align-items:center;gap:30px;@media screen and (max-width:1047px){gap:10px;padding:0 20px;}"]); // const PRNewsList = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 24px;
//   &[aria-hidden='true'] {
//     display: none;
//   }
//   @media screen and (max-width: 1047px) {
//     padding: 0 20px;
//   }
// `

var IRNewsList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Home__IRNewsList",
  componentId: "sc-2heyus-9"
})(["&[aria-hidden='true']{display:none;}@media screen and (max-width:1047px){padding:0 20px;}"]);
var EnNewslist = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Home__EnNewslist",
  componentId: "sc-2heyus-10"
})(["div{display:flex;align-items:center;}p{margin-right:40px;margin-left:50px}time{font-weight:700;font-size:14px;line-height:1.6;letter-spacing:0;color:", ";}a:hover{text-decoration:underline;}"], theme/* theme.colors.textTitle */.r.colors.textTitle);
;// CONCATENATED MODULE: ./src/pages/en/index.tsx



var Home = function Home(_ref) {
  var newsRelease = _ref.newsRelease;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(HomePage, {
    newsRelease: newsRelease
  });
};

var __N_SSG = true;
/* harmony default export */ var en = (Home);

/***/ }),

/***/ 10534:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en",
      function () {
        return __webpack_require__(91909);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(16505)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,9181,5727,4591,9774,2888,179], function() { return __webpack_exec__(10534); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);